const token = require("../js/utils/design-tokens/serializeToken");
module.exports = {
    breakpoints: {
        "breakpoints-xs": token("0"),
        "breakpoints-sm": token("480px"),
        "breakpoints-md": token("768px"),
        "breakpoints-lg": token("1024px"),
        "breakpoints-xl": token("1366px"),
        "breakpoints-2xl": token("1584px"),
        "breakpoints-3xl": token("1920px"),
        "breakpoints-4xl": token("2560px"),
        "breakpoints-5xl": token("3840px"),
    },
    "grid-columns": {
        "grid-columns-xs": token("2"),
        "grid-columns-sm": token("6"),
        "grid-columns-md": token("12"),
        "grid-columns-lg": token("12"),
        "grid-columns-xl": token("12"),
        "grid-columns-2xl": token("12"),
        "grid-columns-3xl": token("12"),
        "grid-columns-4xl": token("12"),
        "grid-columns-5xl": token("12"),
    },
    "grid-gutter-compact": {
        "grid-gutter-compact-xs": token("8px"),
        "grid-gutter-compact-sm": token("8px"),
        "grid-gutter-compact-md": token("16px"),
        "grid-gutter-compact-lg": token("16px"),
        "grid-gutter-compact-xl": token("16px"),
        "grid-gutter-compact-2xl": token("16px"),
        "grid-gutter-compact-3xl": token("24px"),
        "grid-gutter-compact-4xl": token("32px"),
        "grid-gutter-compact-5xl": token("40px"),
    },
    "grid-gutter-default": {
        "grid-gutter-default-xs": token("16px"),
        "grid-gutter-default-sm": token("16px"),
        "grid-gutter-default-md": token("16px"),
        "grid-gutter-default-lg": token("16px"),
        "grid-gutter-default-xl": token("16px"),
        "grid-gutter-default-2xl": token("24px"),
        "grid-gutter-default-3xl": token("32px"),
        "grid-gutter-default-4xl": token("40px"),
        "grid-gutter-default-5xl": token("48px"),
    },
    "grid-gutter-comfy": {
        "grid-gutter-comfy-xs": token("24px"),
        "grid-gutter-comfy-sm": token("24px"),
        "grid-gutter-comfy-md": token("24px"),
        "grid-gutter-comfy-lg": token("24px"),
        "grid-gutter-comfy-xl": token("24px"),
        "grid-gutter-comfy-2xl": token("32px"),
        "grid-gutter-comfy-3xl": token("48px"),
        "grid-gutter-comfy-4xl": token("56px"),
        "grid-gutter-comfy-5xl": token("64px"),
    },
    "grid-margins-compact": {
        "grid-margins-compact-xs": token("16px"),
        "grid-margins-compact-sm": token("16px"),
        "grid-margins-compact-md": token("24px"),
        "grid-margins-compact-lg": token("32px"),
        "grid-margins-compact-xl": token("32px"),
        "grid-margins-compact-2xl": token("48px"),
        "grid-margins-compact-3xl": token("48px"),
        "grid-margins-compact-4xl": token("64px"),
        "grid-margins-compact-5xl": token("96px"),
    },
    "grid-margins-default": {
        "grid-margins-default-xs": token("16px"),
        "grid-margins-default-sm": token("16px"),
        "grid-margins-default-md": token("32px"),
        "grid-margins-default-lg": token("40px"),
        "grid-margins-default-xl": token("48px"),
        "grid-margins-default-2xl": token("64px"),
        "grid-margins-default-3xl": token("72px"),
        "grid-margins-default-4xl": token("96px"),
        "grid-margins-default-5xl": token("128px"),
    },
    "grid-margins-comfy": {
        "grid-margins-comfy-xs": token("24px"),
        "grid-margins-comfy-sm": token("24px"),
        "grid-margins-comfy-md": token("40px"),
        "grid-margins-comfy-lg": token("48px"),
        "grid-margins-comfy-xl": token("56px"),
        "grid-margins-comfy-2xl": token("80px"),
        "grid-margins-comfy-3xl": token("96px"),
        "grid-margins-comfy-4xl": token("128px"),
        "grid-margins-comfy-5xl": token("160px"),
    },
};
